import {
  Scale,
  Building2,
  Heart,
  Home,
  Briefcase,
  HardHat,
  Landmark,
  Shield,
  Lightbulb,
} from "lucide-react";

const areas = [
  { icon: Shield, title: "Criminal Law", desc: "Defence in criminal proceedings, bail applications, and appeals before all courts in Kerala." },
  { icon: Scale, title: "Civil Law", desc: "Civil suits, injunctions, partition suits, and dispute resolution for individuals and businesses." },
  { icon: Heart, title: "Family Law", desc: "Divorce, custody, maintenance, domestic violence cases, and matrimonial disputes." },
  { icon: Home, title: "Property / Real Estate Law", desc: "Land acquisition, title verification, property disputes, registration, and real estate transactions." },
  { icon: Briefcase, title: "Corporate / Business Law", desc: "Company formation, compliance, contract drafting, mergers, and corporate advisory services." },
  { icon: HardHat, title: "Labour Law", desc: "Employment disputes, workplace rights, industrial tribunal matters, and compliance advisory." },
  { icon: Landmark, title: "Banking & Finance Law", desc: "Loan recovery, SARFAESI Act, cheque bounce cases, and banking dispute resolution." },
  { icon: Building2, title: "Constitutional Law", desc: "Writ petitions, fundamental rights enforcement, and public interest litigation before High Courts." },
  { icon: Lightbulb, title: "Intellectual Property Rights", desc: "Trademark registration, copyright protection, patent filing, and IP dispute resolution." },
];

function handleMove(e) {
  const card = e.currentTarget;
  const r = card.getBoundingClientRect();
  card.style.setProperty("--mx", `${e.clientX - r.left}px`);
  card.style.setProperty("--my", `${e.clientY - r.top}px`);
}

export default function PracticeAreas() {
  return (
    <section id="practice" data-testid="practice-areas-section" className="py-28 bg-[#0f1d3a] relative overflow-hidden">
      {/* Aurora glow orbs */}
      <div
        className="aurora-orb delay-1"
        style={{
          width: "520px", height: "520px", top: "10%", left: "-6%",
          background: "radial-gradient(circle, rgba(184,153,104,0.22), transparent 70%)",
        }}
      />
      <div
        className="aurora-orb delay-2"
        style={{
          width: "420px", height: "420px", bottom: "5%", right: "-4%",
          background: "radial-gradient(circle, rgba(224,194,154,0.18), transparent 70%)",
        }}
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-5 px-5 py-2 rounded-full border border-[#b89968]/20 bg-[#b89968]/5 backdrop-blur-sm">
            <Scale className="w-3.5 h-3.5 gold-accent" />
            <span className="text-xs font-semibold tracking-[0.2em] uppercase gold-accent">
              Areas of Expertise
            </span>
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight leading-tight text-white mb-4">
            Practice <span className="italic font-normal gold-accent">Areas</span>
          </h2>
          <div className="section-gold-line mx-auto mb-6" />
          <p className="text-base leading-relaxed text-[#8892ad] max-w-2xl mx-auto">
            Comprehensive legal services across multiple disciplines, providing expert representation
            and counsel for all your legal needs in Kerala.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {areas.map((area) => {
            const Icon = area.icon;
            return (
              <div
                key={area.title}
                data-testid={`practice-area-${area.title.toLowerCase().replace(/[\s/]+/g, "-")}`}
                onMouseMove={handleMove}
                className="practice-card spotlight-card shimmer-border p-7 rounded-xl bg-[#142544]/80 backdrop-blur-sm border border-[#1f2e4a] group hover:-translate-y-1 hover:border-[#b89968]/40 hover:bg-[#1a2c4d] transition-all duration-300 cursor-default"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#b89968]/10 border border-[#b89968]/20 mb-5 group-hover:bg-[#b89968]/20 group-hover:border-[#b89968]/40 transition-all duration-300 shadow-inner shadow-[#b89968]/10">
                  <Icon className="w-5 h-5 gold-accent" />
                </div>
                <h3 className="font-heading text-xl font-semibold tracking-tight text-white mb-3 group-hover:text-[#e0c29a] transition-colors duration-300">
                  {area.title}
                </h3>
                <p className="text-sm leading-relaxed text-[#8892ad] group-hover:text-[#a09890]">
                  {area.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
